import { Gapped } from "react-ui";
// @ts-ignore
import * as React from "react";

import {
    CombineMethodPickerContainer,
    CombineMethodWrapper,
    ModalText,
    OptionDescription,
    OptionIcon,
    OptionTitle,
} from "../Styles/Modals.styles";
import { useCandyTheme } from "../../../../../../Controls/Internals/ThemeProvider/CandyTheme/UseCandyTheme";
import { Icon } from "../../../../../../Controls/Icons/Icon";

interface CombineMethodPickerProps {
    onReplaceClick: () => void;
    onDeepMergeClick?: () => void;
    onMergeClick?: () => void;
    onAddToEndClick?: () => void;
}

export const CombineMethodPicker = ({
    onAddToEndClick,
    onMergeClick,
    onReplaceClick,
    onDeepMergeClick,
}: CombineMethodPickerProps) => {
    const theme = useCandyTheme();

    return (
        <CombineMethodPickerContainer>
            <ModalText>В отчете уже есть документы</ModalText>
            <Gapped vertical gap={theme.size(2)}>
                <CombineMethodWrapper onClick={onReplaceClick} data-tid="ReplaceOption">
                    <OptionIcon>
                        <Icon name={"DocArrowConvertIcon"} size={20} />
                    </OptionIcon>
                    <div>
                        <OptionTitle>Заменить все</OptionTitle>
                        <OptionDescription>Удалит старые данные и добавит новые</OptionDescription>
                    </div>
                </CombineMethodWrapper>
                {!!onAddToEndClick && (
                    <CombineMethodWrapper onClick={onAddToEndClick} data-tid="AddToEndOption">
                        <OptionIcon>
                            <Icon name={"DocsPlusIcon"} size={20} />
                        </OptionIcon>
                        <div>
                            <OptionTitle>Объединить</OptionTitle>
                            <OptionDescription>Добавит новые данные</OptionDescription>
                        </div>
                    </CombineMethodWrapper>
                )}
                {!!onMergeClick && (
                    <CombineMethodWrapper onClick={onMergeClick} data-tid="MergeOption">
                        <OptionIcon>
                            <Icon name={"DocArrowSyncIcon"} size={20} />
                        </OptionIcon>
                        <div>
                            <OptionTitle>Заменить совпадающие</OptionTitle>
                            <OptionDescription>Добавит новые данные и заменит старые при совпадении</OptionDescription>
                        </div>
                    </CombineMethodWrapper>
                )}
                {!!onDeepMergeClick && (
                    <CombineMethodWrapper onClick={onDeepMergeClick} data-tid="DeepMergeOption">
                        <OptionIcon>
                            <Icon name={"DocsPlusIcon"} size={20} />
                        </OptionIcon>
                        <div>
                            <OptionTitle>Объединить</OptionTitle>
                            <OptionDescription>Сохранит все данные и пересчитает значения</OptionDescription>
                        </div>
                    </CombineMethodWrapper>
                )}
            </Gapped>
        </CombineMethodPickerContainer>
    );
};
